import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import AttractAndSourceContainer from '~/features/attract-n-source'
import en_attract_n_source from '../../../public/locales/en/attract-and-source.json'
import jp_attract_n_source from '../../../public/locales/ja/attract-and-source.json'
// import jsonLd from '../../../public/schema.json'

const AttractAndSourcePage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      {/* <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      /> */}
      <HeadMetaTags
        title={t('meta:ats_attract_and_source:meta_title')}
        description={t('meta:ats_attract_and_source:meta_description')}
      />
      <AttractAndSourceContainer />
    </>
  )
}

export default withTranslateProvider(AttractAndSourcePage, {
  en: { attract_n_source: en_attract_n_source },
  ja: { attract_n_source: jp_attract_n_source }
})
